import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { DataResolver } from '../services/data-resolve.service';
import { CruiseService } from '../services/cruise.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  title = "Book Cruise Tour Packages with Akbar Travels";
  private baseURL: any = ''; private fullURL: any = ''; public last_access: Date; public loginType = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, platformLocation: PlatformLocation, private router: Router, private titleService: Title, private meta: Meta, private dataResolve: DataResolver, private route: ActivatedRoute,
    private cruiserService: CruiseService) {
    this.fullURL = (platformLocation as any).location.pathname;
    try {
      var merchantdata = this.route.snapshot.data['merchantsetup'];
      var orgData = JSON.parse(JSON.stringify(merchantdata.d));
      this.cruiserService.saveSetupData(orgData);
      // sessionStorage.setItem("merchantData", orgData);
    } catch (errormsg) {
      console.log(errormsg);
    }
  }

  ngOnInit() {
    //this.titleService.setTitle("Book Cruise Tour Packages with Akbar Travels");
    // Add Meta Tags
    try {
      // if (this.orgsearchData.TitleTag == "") this.titleService.setTitle("Book Cruise Tour Packages with Akbar Travels"); else
      //   this.titleService.setTitle(this.orgsearchData.TitleTag);
      this.meta.addTag({ name: 'Description', content: "Book Cruise Ship Packages Online - Akbar Travels provides you International &amp; India Cruise Packages Online at best prices. Visit your dream destination with cruise tour packages online with us. Book your cruise holiday package today!" });
      this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });
      this.titleService.setTitle("Cruise Ship Packages: Cruise Ticket Booking Online in India at Best Price | Akbar Travels");
      this.meta.removeTag('Description');
    } catch (errormsg) { }

    if (isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem("loginType")) {
        sessionStorage.setItem("loginType", "B2C"); this.loginType = "B2C";
      } else { this.loginType = "B2B" }

      // Check for last access if it is more than 30 mins then expire session
      if (this.loginType == "B2B") {
        if (isPlatformBrowser(this.platformId)) {
          if (sessionStorage.getItem("last_access")) {
            this.last_access = new Date(Number(sessionStorage.getItem("last_access")));
            var diff = this.diff_minutes(this.last_access, new Date());
            if (diff > 20) {
              sessionStorage.clear();
              this.router.navigate(["https://agents.akbartravelsonline.com/MyAccount/Login"]);
            }
          } else {
            var d = new Date();
            sessionStorage.setItem("last_access", JSON.stringify(d.getTime()));
          }
        }
      }
    }
  }

  diff_minutes(dt2: Date, dt1: Date) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }
}
